import React from "react";
import LgvCountryField from "../../../components/LgvCountryField";
import { QuestionItem } from "../../../types/form";

interface CountryFieldRendererProps {
  question: QuestionItem;
  inputName: string;
  currentValue: unknown;
  setFormData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  handleMultipleEntryChange: (
    inputName: string,
    idx: number,
    value: unknown,
  ) => void;
  handleAddEntry: (inputName: string) => void;
  handleRemoveEntry: (inputName: string, entryIdx: number) => void;
  readOnly?: boolean;
}

const CountryFieldRenderer: React.FC<CountryFieldRendererProps> = ({
  question,
  inputName,
  currentValue,
  setFormData,
  handleMultipleEntryChange,
  handleAddEntry,
  handleRemoveEntry,
  readOnly = false,
}) => {
  if (question.allowMultipleAnswers) {
    const entriesArray = Array.isArray(currentValue)
      ? currentValue
      : [currentValue ?? ""];

    return (
      <div className="space-y-3">
        {entriesArray.map((entryValue, idx) => (
          <div key={idx} className="flex items-center gap-2">
            <LgvCountryField
              id={idx === 0 ? inputName : `${inputName}-${idx}`}
              name={idx === 0 ? inputName : undefined}
              value={entryValue}
              disabled={readOnly}
              required={question.isRequired}
              placeholder={question.placeholder || "Select country..."}
              className="flex-1"
              onChange={(country) =>
                handleMultipleEntryChange(inputName, idx, country ?? "")
              }
            />
            {idx > 0 && (
              <button
                type="button"
                onClick={() => handleRemoveEntry(inputName, idx)}
                disabled={readOnly}
                className="px-3 py-2 text-red-600 border border-red-600 rounded-md hover:bg-red-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Remove
              </button>
            )}
          </div>
        ))}
        <button
          type="button"
          onClick={() => handleAddEntry(inputName)}
          disabled={readOnly}
          className="px-4 py-2 bg-[#1B365D] text-white rounded-md hover:bg-[#152a4a] transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          + Add Another
        </button>
      </div>
    );
  }

  return (
    <LgvCountryField
      id={inputName}
      name={inputName}
      value={currentValue}
      disabled={readOnly}
      required={question.isRequired}
      placeholder={question.placeholder || "Select country..."}
      onChange={(country) =>
        setFormData((prev) => ({
          ...prev,
          [inputName]: country ?? "",
        }))
      }
    />
  );
};

export default CountryFieldRenderer;
